function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocShoppingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 28H6V10h3v6h2v-6h10v6h2v-6h3v18zM16 4a5.009 5.009 0 014.899 4h-9.798A5.009 5.009 0 0116 4zm11 4h-4.08c-.488-3.387-3.4-6-6.92-6S9.568 4.613 9.08 8H5a1 1 0 00-1 1v20a1 1 0 001 1h22a1 1 0 001-1V9a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconPocShoppingFilled;